module.exports = __webpack_public_path__ + "static/media/layers.9722f7b6.svg";